import { TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Controller } from "react-hook-form";

export default function DatabricksForm(props) {
  const { schemaLoading, handleChangeInput, errors, control } = props;

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Controller
          control={control}
          name="catalogName"
          // defaultValue={connectionData?.catalogName ?? ""}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              // disabled={Boolean(connectionData?.catalogName)}
              disabled={Boolean(schemaLoading)}
              label={"Catalog Name"}
              required
              fullWidth
              error={Boolean(errors?.catalogName)}
              variant="outlined"
              size="small"
              onChange={(e) => handleChangeInput(e, field)}
            />
          )}
        />
      </Grid>

      <Grid size={12}>
        <Controller
          control={control}
          name="serverHostname"
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              // disabled={Boolean(connectionData?.serverHostname)}
              disabled={Boolean(schemaLoading)}
              label={"Server Host Name"}
              placeholder="eg: adb-4327469464531522.2.azuredatabricks.net"
              required
              fullWidth
              error={Boolean(errors?.serverHostname)}
              variant="outlined"
              size="small"
              onChange={(e) => handleChangeInput(e, field)}
            />
          )}
        />
      </Grid>

      <Grid size={12}>
        <Controller
          control={control}
          name="httpPath"
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              // disabled={Boolean(connectionData?.httpPath)}
              disabled={Boolean(schemaLoading)}
              label={"Http Path"}
              placeholder="eg: /sql/1.0/warehouses/f11f65200dfe6353"
              required
              fullWidth
              error={Boolean(errors?.httpPath)}
              variant="outlined"
              size="small"
              onChange={(e) => handleChangeInput(e, field)}
            />
          )}
        />
      </Grid>

      <Grid size={12}>
        <Controller
          control={control}
          name="token"
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              // disabled={Boolean(connectionData?.token)}
              disabled={Boolean(schemaLoading)}
              label={"Token"}
              required
              fullWidth
              error={Boolean(errors?.token)}
              variant="outlined"
              size="small"
              onChange={(e) => handleChangeInput(e, field)}
            />
          )}
        />
      </Grid>
    </Grid>
  );
}
